import { defineAsyncComponent, hydrateOnVisible } from 'vue'

import type { AsyncComponentLoader } from 'vue'

type HydrationOptions = {
  component?: boolean,
  deferPreload?: boolean,
  deferHydration?: boolean,
  hydrateBeforeVisible?: boolean
}

type AsyncParagraphTypeOptions = HydrationOptions & (
  | { loader?: undefined, modulePath?: undefined }
  | { loader: AsyncComponentLoader, modulePath: string }
)

const hydrationModulePreloadModes = new Map<string, 'defer' | 'preload'>()

function asyncParagraphType (name: string, options: AsyncParagraphTypeOptions = {}) {
  const { component = false, deferPreload = false, deferHydration = true, loader, hydrateBeforeVisible = false, modulePath } = options
  hydrationModulePreloadModes.set(
    modulePath ?? `components/paragraph-types/ParagraphType${component ? 'VueComponent/' : ''}${name}.vue`,
    deferPreload ? 'defer' : 'preload'
  )

  const componentLoader = loader ?? (() => component ? import(`./ParagraphTypeVueComponent/${name}.vue`) : import(`./ParagraphType${name}.vue`))
  if (!deferHydration) return defineAsyncComponent(componentLoader)

  return defineAsyncComponent({
    loader: componentLoader,
    hydrate: hydrateOnVisible(hydrateBeforeVisible ? { rootMargin: '1000px 0px' } : undefined)
  })
}

export { asyncParagraphType, hydrationModulePreloadModes }
